import { Component, OnInit, Input, ViewChild, ElementRef, Renderer, AfterViewInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import 'rxjs/Rx';
import { Observable } from 'rxjs/Observable';

import { OrderService } from '../../services/order.service';
import { InventoryService } from '../../services/inventory.service';
import { PrintService } from '../../services/print.service';
import { StorageService } from 'app/services/storage.service';
import { PackagingService} from '../../services/packaging.service'
import { Scan } from '../scan';
import { Fee } from '../../orders/fee';
import { AlertService } from '../../alert';
import { AuthenticationService, Token } from '../../services';
import { min } from 'rxjs/operator/min';

@Component({
  selector: 'order-detail',
  providers: [OrderService, InventoryService, PrintService, StorageService, PackagingService],
  templateUrl: './order-detail.component.html',
  styleUrls: ['./order-detail.component.css']
})
export class OrderDetailComponent implements OnInit, AfterViewInit {

  loading = false;
  order: any;
  trackingNumbers: any[];
  fees: any[];
  scans: any[];
  articles: any[] = [];
  curentPos: number;
  query: any;
  articleOVP: any[] = [];
  mlabel: boolean = false;
  labelModel: string;
  @ViewChild("myBarcode")
  private _inputElement: ElementRef;
  cart: any[] = [];
  selectedStock: string = null;
  selectedArticle: string = null;
  selectedCount: number = 0;
  collapsed:boolean = true;
  activateLabel: boolean = false;
  labelCount: number = 0;
  finalPackaging: any[] = [];

  private CART: string = 'shopping_cart';

  constructor(
    private orderService: OrderService,
    private route: ActivatedRoute,
    private router: Router,
    private alertService: AlertService,
    private renderer: Renderer,
    private inventoryService: InventoryService,
    private printService: PrintService,
    private storageService: StorageService,
    private packagingService: PackagingService,
    private authenticationService: AuthenticationService) { }

  ngOnInit() {
    let reference = this.route.snapshot.params['id'];
    this.getOrder(reference);
  }

  ngAfterViewInit() {
    this.doFocus();
  }

  doFocus() {
    if (this._inputElement) {
      this._inputElement.nativeElement.focus();
    }
    this.collapsed = !this.collapsed;
    if (this.collapsed) {
      this.curentPos = null;
    }
  }

  updateCart() {
    this.loading = true;
    this.inventoryService.getArticlesOnShelf(this.CART)
      .subscribe(
        data => {
          this.cart = data;
          this.cart.forEach(article => {
            article.shelves.forEach(shelf => {  
              if (shelf.name == this.CART) {
                // match with scans
                if (this.scans != null) {
                  for (let scan of this.scans) {
                    if (scan.articleRef == article.articleRef) {
                      Observable.of(shelf.numberOfItems, scan.numberOfItems).min()
                      .subscribe(x => article.onCart = x);
                    }
                  }
                }
              }
            })
          });
          this.cart = this.cart.filter(article => article.onCart>0);
          this.loading = false;
          this.alertService.clear();
        },
        error => {
          this.alertService.error(error);
          this.loading = false;
        });
  }

  isTotalComplete() {
    for (let i = 0; i < this.order.orderArticles.length; i++) {
      if (!this.isComplete(this.order.orderArticles[i])) {
        return false;
      }
    }
    return true;
  }

  getScanMenge(position) {
    if (position == null || this.scans == null) {
      return 0;
    }
    for (let i = 0; i < this.scans.length; i++) {
      if (this.scans[i].articleRef == position.articleRef) {
        return this.scans[i].numberOfItems;
      }
    }
    return 0;
  }

  isComplete(position) {
    if (position == null || this.scans == null) {
      return false;
    }
    for (let i = 0; i < this.scans.length; i++) {
      if (this.scans[i].articleRef == position.articleRef && this.scans[i].numberOfItems == position.numberOfItems) {
        return true;
      }
    }
    return false;
  }

  ovpScan(event) {
    if (this.articleOVP.includes(event)) {
      this.removeOVP(event);
    } else {
      this.articleOVP.push(event);
    }
    this.doFocus();
  }

  removeOVP(reference: string) {
    for (let i = this.articleOVP.length - 1; i >= 0; i--) {
      if (this.articleOVP[i] == reference) {
        this.articleOVP.splice(i, 1);
        break;
      }
    }
  }

  isOVPArticle(reference: string) {
    return this.articleOVP.includes(reference);
  }

  manualScan(event) {
    let scan = new Scan();
    if (this.isOVPArticle(event.articleRef)) { this.removeOVP(event.articleRef)}
    scan.articleRef = event.articleRef;
    scan.numberOfItems = event.numberOfItems;
    this.selectedCount = scan.numberOfItems;
    this.orderService.addScan(this.order.reference, scan)
      .subscribe(
        data => {
          this.selectedArticle = data;
          this.getScans(this.order.reference);
          this.selectedStock = null;
          this.updateStorageProcessing();
          this.doFocus();
          this.alertService.clear();
        },
        error => {
          this.alertService.error(error);
        });
    this.doFocus();
  }

  getScans(reference: string) {
    this.orderService.getScans(reference)
      .subscribe(
        data => {
          this.scans = data;
          this.updateCart();
          this.doFocus();
          this.alertService.clear();
        },
        error => {
          this.alertService.error(error);
        });
  }

  resetScan(event) {
    this.orderService.resetScan(this.order.reference, event)
      .subscribe(
        data => {
          this.getScans(this.order.reference);
          this.curentPos = null;
          this.doFocus();
          this.alertService.clear();
        },
        error => {
          this.alertService.error(error);
        });
  }

  addPack(packagingName: string) {
    this.packagingService.addOrderPackaging(packagingName, this.order.reference)
      .subscribe(
        data => {
          this.packagingService.getPackagingByName(packagingName)
            .subscribe(
              packaging => {
                if (packaging.price > 0) {
                  let fee = new Fee();
                  fee.orderReference = this.order.reference;
                  fee.description = packagingName;
                  fee.type = "Package";
                  fee.numberOfItems = 1;
                  fee.feeDate = new Date();
                  fee.fee = packaging.price;
                  this.orderService.addFee(fee)
                    .subscribe(
                      data => {
                        this.getFees(this.order.reference);
                        this.getOrder(this.order.reference);
                        this.alertService.clear();
                      },
                      error => {
                        this.alertService.error(error);
                      });
                } else {
                  this.getOrder(this.order.reference);
                  this.alertService.clear();
                }
              },
              error => {
                this.alertService.error(error);
              });
            },
            error => {
              this.alertService.error(error);
            });
  }

  deletePack(packagingName: string) {
    this.packagingService.deleteOrderPackaging(packagingName, this.order.reference)
      .subscribe(data => {
        this.orderService.getFees(this.order.reference)
          .subscribe(
            feeItems => {
              for (let fee of feeItems) {
                if (fee.description == packagingName) {
                  this.orderService.removeFee(fee.id)
                    .subscribe(
                      data => {
                        this.alertService.clear();
                      },
                      error => {
                        this.alertService.error(error);
                      });
                }
              }
              this.getOrder(this.order.reference);
            },
            error => {
              this.alertService.error(error);
            });
        this.alertService.clear();
      },
      error => {
        this.alertService.error(error);
      });
    
  }

  barcode(event: string) {
    if (event == null || event == '') return;
    this.query = null;
    let found: boolean = false;

      // Check if container exists in storageService
      // If container does not exist we might have scanned an article
      this.storageService.getContainer(event).subscribe(data => {  
        this.selectedStock = event;
        this.inventoryService.getArticlesOnShelf(this.selectedStock) 
          .subscribe(data => {
              for (let article of data) {
                for (let position of this.order.orderArticles) {
                  if (article.articleRef == position.articleRef) { // validate that articles on this lagerplatz belong to this order
                    found = true;
                    break; // article found
                  }
                }
              }
              if (!found) {
                this.alertService.error("No article of this order can be found on " + this.selectedStock, false);
                this.selectedStock = null; 
              } else {
                this.alertService.clear();
              }
          }, error => {
            this.selectedStock = null;
            this.alertService.error("Fehler in der Lagerplatzsuche", false);
          });
          this.selectedArticle = null;
          this.doFocus();
          return;
      }, error => {
        // If container does not exist, we might have scanned an article
      });
    
      if (this.selectedStock) { // we scanned an article and the storage place was already scanned previously
          let articleFound: boolean = false;
          let shelfFound: boolean = false;
          this.inventoryService.getArticleByBarcode(event)
            .subscribe(
              data => {
                // validate that scanned article belongs to this order
                for (let position of this.order.orderArticles) {
                  if (data.articleRef == position.articleRef) { 
                    articleFound = true;
                    break; // article found
                  }
                }
                if (!articleFound) {
                  this.alertService.error("The scanned article does not belong to this order" , false);
                  this.selectedArticle = null;
                  return;
                } else {
                  this.alertService.clear();
                }
                // validate that scanned article exists on this storage place
                this.inventoryService.getShelves(data.articleRef)
                .subscribe(
                  data => {
                    for (let item of data) {
                      if (item.storage == this.authenticationService.getStorageName() && item.name == this.selectedStock) {
                        shelfFound = true;
                        break;
                      }
                    }
                    if (!shelfFound) {
                      this.alertService.error("The scanned article does not exist on this shelf" , false);
                      this.selectedArticle = null;
                      return;
                    } else {
                      this.alertService.clear();
                    }
                    let scan = new Scan();
                    scan.barcode = event;
                    scan.numberOfItems = 1;
                    this.selectedCount = 1;
                    if (this.isOVPArticle(data.articleRef)) {
                      scan.numberOfItems = data.ovpitems;
                      this.selectedCount = data.ovpitems;
                    }
                    this.orderService.addScan(this.order.reference, scan)
                      .subscribe(
                        data => {
                          this.selectedArticle = data;
                          this.getScans(this.order.reference);
                          this.updateStorageProcessing();
                          this.alertService.clear();
                        },
                        error => {
                          this.alertService.error(error);
                          this.selectedArticle = null;
                      });
                  },
                  error => {
                    this.alertService.error(error);
                  });
                },
              error => {
                this.alertService.error(error);
                this.selectedArticle = null;
                return;
            });          
      } else { // we scanned an article but no storage place selected
        this.alertService.error("You need so scan a storage place first OR storage place does not exist!");
        this.selectedArticle = null;
      }
  }

  updateStorageProcessing() {
    console.log("updateStorageProcessing " + this.selectedArticle + " " + this.selectedStock + " " + this.selectedCount);
    if (this.selectedCount===0) {
      this.selectedCount = 1;
    }
    if (this.selectedArticle != null && this.selectedStock != null) {
      this.inventoryService.changeItems(this.selectedArticle, -(this.selectedCount), "Scanning", this.selectedStock, this.CART)
        .subscribe(
          data => {
            this.selectedArticle = null;
            this.updateCart();
            this.alertService.clear();
          },
          error => {
            this.alertService.error(error);
            this.selectedArticle = null;
          });
    } else if (this.selectedArticle != null && this.selectedStock == null) {
      this.inventoryService.changeItems(this.selectedArticle, this.selectedCount, "Manual scan", this.CART, null)
      .subscribe(
        data => {
          this.selectedArticle = null;
          this.updateCart();
          this.alertService.clear();
        },
        error => {
          this.alertService.error(error);
          this.selectedArticle = null;
        });
    }
  }

  deliveryNote() {
    this.loading = true;
    this.orderService.hasDeliveryNote(this.authenticationService.getToken().value, this.order.reference)
      .subscribe(
        data => {
          window.open(this.orderService.getDownloadURLNote(this.authenticationService.getToken().value, this.order.reference));
          this.loading = false;
          this.doFocus();
          this.alertService.clear();
        },
        error => {
          this.alertService.error(error);
          this.loading = false;
        });
  }

  printDeliveryNote(): void {
    this._printDeliveryNote();
  }

  private async _printDeliveryNote(): Promise<void> {
    // first download
    this.deliveryNote();
    // then print
    await this.sleep(1000);
    await this.printService.print('mainPrinter', this.order.reference).toPromise();
  }

  sleep(ms) {
    return new Promise((resolve) => {
      setTimeout(resolve, ms);
    });
  }

  getAddress() {
    let result: string = "";
    result = result + this.order.recipient.name1;
    result = result + (this.order.recipient.name2 == null ? "" : " " + this.order.recipient.name2);
    result = result + (this.order.recipient.name3 == null ? "" : " " + this.order.recipient.name3);
    result = result + ",";
    result = result + (this.order.recipient.street == null ? "" : " " + this.order.recipient.street);
    result = result + (this.order.recipient.houseNo == null ? "" : " " + this.order.recipient.houseNo);
    result = result + (this.order.recipient.poBox == null ? "" : " " + this.order.recipient.poBox);
    result = result + ",";
    result = result + (this.order.recipient.zip == null ? "" : " " + this.order.recipient.zip);
    result = result + (this.order.recipient.city == null ? "" : " " + this.order.recipient.city);
    return result;
  }

  removeFee(event) {
    this.loading = true;
    this.orderService.removeFee(event.id)
      .subscribe(
        data => {
          this.getFees(this.order.reference);
          this.alertService.clear();
        },
        error => {
          this.alertService.error(error);
          this.loading = false;
        });
  }

  remove(event) {
    this.loading = true;
    this.orderService.removeTrackingNumber(event)
      .subscribe(
        data => {
          this.getOrder(this.order.reference);
          this.alertService.clear();
        },
        error => {
          this.alertService.error(error);
          this.loading = false;
        });
  }

  addManualTracking(event) {
    this.labelModel = event;
  }

  generateLabelManual() {
    if (!this.isTotalComplete()) {
      this.alertService.error('Funktion nur möglich wenn alle Artikel bestätigt');
      return;
    }
    this.loading = true;
    this.orderService.addLabelManuall(this.order.reference, this.labelModel, this.order.projectId)
      .subscribe(
        data => {
          this.alertService.success("Label erfolgreich aufgenommen");
          this.getOrder(this.order.reference);
          this.loading = false;
        },
        error => {
          this.alertService.error(error);
          this.loading = false;
        });
    this.labelModel = null;
  }

  addLabel() {
    this.activateLabel = !this.activateLabel;
    this.mlabel = false;
  }

  addLabelManual() {
    this.activateLabel = false;
    this.mlabel = !this.mlabel;
  }

  generateLabel(event) {
    // post packaging information to order in s3
    this.orderService.updateShippingOrderPackaging(this.order.businessKey, this.finalPackaging)
      .subscribe(
        data => {
          if (event) {
            this.generateLabelManual();
          } else {
            this.generateNewLabel();
          }
        },
        error => {
          this.alertService.error(error);
          this.loading = false;
        }
      );

    
  }


  generateNewLabel() {
    if (!this.isTotalComplete()) {
      this.alertService.error('Labelbezug nur möglich wenn alle Artikel bestätigt');
      return;
    }
    this.loading = true;
    let tracks = this.trackingNumbers.length;
    if (tracks == this.labelCount) {
      this.alertService.success("Anzahl Label und Kartons stimmen bereits überein");
      this.loading = false;
      return;
    }
    //for (let i = 1; i <= this.labelCount; i++) {
      // call rest-service only once with businessKey
      // and all necessary labels will be generated
      this.orderService.addLabel(this.order.businessKey)  
        .subscribe(
          data => {
            this.alertService.success("Label erfolgreich erstellt");
            this.getOrder(this.order.reference);
          },
          error => {
            this.alertService.error(error);
            this.loading = false;
          });
    //}
    this.loading = false;
  }

  getTrackingNumbers(reference: string) {
    this.loading = true;
    this.orderService.getTrackingNumbers(reference)
      .subscribe(
        data => {
          this.trackingNumbers = data;
          this.getFees(reference);
          this.alertService.clear();
        },
        error => {
          this.alertService.error(error);
          this.loading = false;
        });
  }

  getFees(reference: string) {
    this.loading = true;
    this.orderService.getFees(reference)
      .subscribe(
        data => {
          this.fees = data;
          this.doFocus();
          this.loading = false;
          this.alertService.clear();
        },
        error => {
          this.alertService.error(error);
          this.loading = false;
        });
  }

  getOrder(reference: string) {
    this.loading = true;
    this.orderService.getOrder(reference)
      .subscribe(
        data => {
          this.order = data;
          this.getTrackingNumbers(reference);
          this.getScans(reference);
          this.updateCart();
          this.curentPos = null;
          this.doFocus();
          this.alertService.clear();
        },
        error => {
          this.alertService.error(error);
          this.loading = false;
        });
  }

  changeStatus(status: string) {
    this.loading = true;
    this.orderService.updateStatus(this.order.reference, status)
      .subscribe(
        data => {
          this.getOrder(this.order.reference);
          this.alertService.clear();
        },
        error => {
          this.alertService.error(error);
          this.loading = false;
        });
  }

  select(event) {
    this.router.navigate(['/events', event.reference]);
  }

  selectLabel(event) {
    this.labelCount = event;
  }

  updatePackaging(event) {
    this.finalPackaging = event;
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/fulfillment.release/src/app/orders/order-detail/order-detail.component.ts